// /src/backendServices/userManagment/api.ts

import   axios                                        from 'axios';


import { BackendResponse                            ,
         handleError                                } from '../../dataTypes/backendServicesManagment/types';

import { User                                       ,
         initializedUser                            ,
         EnrichedUser                               ,
         initializedEnrichedUser                    ,
         GetUserListParams                          ,
         UserAuthenticationResult                   ,
         UserStatus                                 ,
         initializedUserStatus                      } from '../../dataTypes/userManagment/types';

import { convertStringToDate                        ,
         convertDateToString                        } from '../../dataTypes/timeManagment/utils';

import { initializedDetailledIpAddressInformations  } from '../../dataTypes/networkManagment/types';

import { API_URLS                                   } from '../urls';

import { getUserAgentInformations                   } from '../../utils/utils_userAgent';
import { getAppInformations                         } from '../../utils/utils_app';

export interface BackendResponse_UserList extends BackendResponse<User[]> {}

export const getUserList = async (params: GetUserListParams = {}): Promise<BackendResponse_UserList> => {

  let url = API_URLS.getUserList;

  const queryParams = new URLSearchParams();

  if ( params.beginningDate                         ) queryParams.append ( 'beginningDateStr' , convertDateToString ( params.beginningDate, 'yyyy/MM/dd HH:mm') );
  if ( params.endingDate                            ) queryParams.append ( 'endingDateStr'    , convertDateToString ( params.endingDate,    'yyyy/MM/dd HH:mm') );
  if ( params.filter        && params.filter !== '' ) queryParams.append ( 'filter'           ,                       params.filter                             );
  if ( params.status        && params.status !== '' ) queryParams.append ( 'status'           ,                       params.status                             );

  if (queryParams.toString()) url += `?${queryParams.toString()}`;

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
           const users: User[] = response.data.map ( (rawUser: any) => {

             const defaultUser = initializedUser();

             return {

               ...defaultUser,
               id                  : rawUser.id ?? defaultUser.id,
               creationDate        : rawUser.creationDate ? convertStringToDate(rawUser.creationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.creationDate,
               creationIpAddress   : rawUser.creationIpAddress ?? defaultUser.creationIpAddress,
               email               : rawUser.email ?? defaultUser.email,
               emailValidationDate : rawUser.emailValidationDate ? convertStringToDate(rawUser.emailValidationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.emailValidationDate,
               status              : rawUser.status ?? defaultUser.status,
               statusDeadline      : rawUser.statusDeadline ? convertStringToDate(rawUser.statusDeadline, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.statusDeadline,
               locked              : (rawUser.locked === 'true') ?? defaultUser.locked,

  nextStatus                                      : rawUser.nextStatus ?? defaultUser.nextStatus,
  nextStatusRequestDate                           : rawUser.nextStatusRequestDate ? new Date(rawUser.nextStatusRequestDate) : null,
  nextStatusRequestIpAddress                      : rawUser.nextStatusRequestIpAddress ?? defaultUser.nextStatusRequestIpAddress,
  state                                           : rawUser.state ?? defaultUser.state,
  closureDate                                     : rawUser.closureDate ? new Date(rawUser.closureDate) : null,
  closureIpAddress                                : rawUser.closureIpAddress ?? defaultUser.closureIpAddress,
  lastBanDate                                     : rawUser.lastBanDate ? new Date(rawUser.lastBanDate) : null,
  lastUpdateIpAddress                             : rawUser.lastUpdateIpAddress ?? defaultUser.lastUpdateIpAddress,
  lastUpdateDate                                  : rawUser.lastUpdateDate ? new Date(rawUser.lastUpdateDate) : null,
  emailValidationToken                            : rawUser.emailValidationToken ?? defaultUser.emailValidationToken,
  emailValidationIpAddress                        : rawUser.emailValidationIpAddress ?? defaultUser.emailValidationIpAddress,
  emailValidationReminder                         : rawUser.emailValidationReminder ?? defaultUser.emailValidationReminder,
  lastPasswordResetRequestIpAddress               : rawUser.lastPasswordResetRequestIpAddress ?? defaultUser.lastPasswordResetRequestIpAddress,
  lastPasswordResetRequestDate                    : new Date           ( rawUser.lastPasswordResetRequestDate    ?? new Date() ),
  lastPasswordResetToken                          : rawUser.lastPasswordResetToken ?? defaultUser.lastPasswordResetToken,
  lastPasswordResetIpAddress                      : rawUser.lastPasswordResetIpAddress ?? defaultUser.lastPasswordResetIpAddress,
  lastPasswordResetDate                           : new Date           ( rawUser.lastPasswordResetDate    ?? new Date() ),
  lastEmailResetRequestIpAddress                  : rawUser.lastEmailResetRequestIpAddress ?? defaultUser.lastEmailResetRequestIpAddress,
  lastEmailResetRequestDate                       : new Date           ( rawUser.lastEmailResetRequestDate    ?? new Date() ),
  lastEmailResetToken                             : rawUser.lastEmailResetToken ?? defaultUser.lastEmailResetToken,
  lastEmailResetIpAddress                         : rawUser.lastEmailResetIpAddress ?? defaultUser.lastEmailResetIpAddress,
  lastEmailResetDate                              : new Date           ( rawUser.lastEmailResetDate    ?? new Date() ),
  lastEmailResetPreviousEmail                     : rawUser.lastEmailResetPreviousEmail ?? defaultUser.lastEmailResetPreviousEmail,
  lastEmailResetPreviousEmailValidationToken      : rawUser.lastEmailResetPreviousEmailValidationToken ?? defaultUser.lastEmailResetPreviousEmailValidationToken,
  lastEmailResetPreviousEmailValidationIpAddress  : rawUser.lastEmailResetPreviousEmailValidationIpAddress ?? defaultUser.lastEmailResetPreviousEmailValidationIpAddress,
  lastEmailResetPreviousEmailValidationDate       : new Date           ( rawUser.lastEmailResetPreviousEmailValidationDate    ?? new Date() ),

  ipApiCom_country : rawUser.ipApiCom_country,
  ipApiCom_city    : rawUser.ipApiCom_city,
  ipApiCom_lat     : rawUser.ipApiCom_lat,
  ipApiCom_lon     : rawUser.ipApiCom_lon,
  ipApiCom_isp     : rawUser.ipApiCom_isp,

               firstname           : rawUser.firstname ?? defaultUser.firstname,
               lastname            : rawUser.lastname ?? defaultUser.lastname,
               sex                 : rawUser.sex ?? defaultUser.sex,
               birthday            : rawUser.birthday ? convertStringToDate(rawUser.birthday, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.birthday,
               address             : rawUser.address ?? defaultUser.address,
               address2            : rawUser.address2 ?? defaultUser.address2,
               address3            : rawUser.address3 ?? defaultUser.address3,
               zipCode             : rawUser.zipCode ?? defaultUser.zipCode,
               city                : rawUser.city ?? defaultUser.city,
               country             : rawUser.country ?? defaultUser.country,
               phoneNumber         : rawUser.phoneNumber ?? defaultUser.phoneNumber,
			   
               lastLoginDate       : rawUser.lastLoginDate ? convertStringToDate(rawUser.lastLoginDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.lastLoginDate,
               lastLoginIpAddress  : rawUser.lastLoginIpAddress ?? defaultUser.lastLoginIpAddress,
               lastLoginCity       : rawUser.lastLoginCity ?? defaultUser.lastLoginCity,

               purchases           : rawUser.purchases ?? defaultUser.purchases,
             };
           } );

           return {
                   code    : 1,
                   comment : 'La récupération des utilisateurs est terminée.',
                   payload : users,
                  };
          }
     else {
           return handleError<User[]>(response.status, 'Réponse non-200 de l\'API', []);
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<User[]>(-101, error.response?.data?.detail ?? error.message, []);
     }

    return handleError<User[]>(-102, 'Erreur inconnue', []);
   }
 };

export interface BackendResponse_User extends BackendResponse<User> {}

export const getUserById = async (userId: number): Promise<BackendResponse_User> => {


  const baseUrl = API_URLS.getUserById;
  const url     = baseUrl.replace('{id}', `${userId}`);

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
           const defaultUser = initializedUser();
           const rawUser     = response.data

           const user: User = {

               ...defaultUser,
               id                  : rawUser.id ?? defaultUser.id,
               creationDate        : rawUser.creationDate ? convertStringToDate(rawUser.creationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.creationDate,
               creationIpAddress   : rawUser.creationIpAddress ?? defaultUser.creationIpAddress,
               email               : rawUser.email ?? defaultUser.email,
               emailValidationDate : rawUser.emailValidationDate ? convertStringToDate(rawUser.emailValidationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.emailValidationDate,
               status              : rawUser.status ?? defaultUser.status,
               statusDeadline      : rawUser.statusDeadline ? convertStringToDate(rawUser.statusDeadline, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.statusDeadline,
               locked              : (rawUser.locked === 'true') ?? defaultUser.locked,

  nextStatus                                      : rawUser.nextStatus ?? defaultUser.nextStatus,
  nextStatusRequestDate                           : rawUser.nextStatusRequestDate ? new Date(rawUser.nextStatusRequestDate) : null,
  nextStatusRequestIpAddress                      : rawUser.nextStatusRequestIpAddress ?? defaultUser.nextStatusRequestIpAddress,
  state                                           : rawUser.state ?? defaultUser.state,
  closureDate                                     : rawUser.closureDate ? new Date(rawUser.closureDate) : null,
  closureIpAddress                                : rawUser.closureIpAddress ?? defaultUser.closureIpAddress,
  lastBanDate                                     : rawUser.lastBanDate ? new Date(rawUser.lastBanDate) : null,
  lastUpdateIpAddress                             : rawUser.lastUpdateIpAddress ?? defaultUser.lastUpdateIpAddress,
  lastUpdateDate                                  : rawUser.lastUpdateDate ? new Date(rawUser.lastUpdateDate) : null,
  emailValidationToken                            : rawUser.emailValidationToken ?? defaultUser.emailValidationToken,
  emailValidationIpAddress                        : rawUser.emailValidationIpAddress ?? defaultUser.emailValidationIpAddress,
  emailValidationReminder                         : rawUser.emailValidationReminder ?? defaultUser.emailValidationReminder,
  lastPasswordResetRequestIpAddress               : rawUser.lastPasswordResetRequestIpAddress ?? defaultUser.lastPasswordResetRequestIpAddress,
  lastPasswordResetRequestDate                    : new Date           ( rawUser.lastPasswordResetRequestDate    ?? new Date() ),
  lastPasswordResetToken                          : rawUser.lastPasswordResetToken ?? defaultUser.lastPasswordResetToken,
  lastPasswordResetIpAddress                      : rawUser.lastPasswordResetIpAddress ?? defaultUser.lastPasswordResetIpAddress,
  lastPasswordResetDate                           : new Date           ( rawUser.lastPasswordResetDate    ?? new Date() ),
  lastEmailResetRequestIpAddress                  : rawUser.lastEmailResetRequestIpAddress ?? defaultUser.lastEmailResetRequestIpAddress,
  lastEmailResetRequestDate                       : new Date           ( rawUser.lastEmailResetRequestDate    ?? new Date() ),
  lastEmailResetToken                             : rawUser.lastEmailResetToken ?? defaultUser.lastEmailResetToken,
  lastEmailResetIpAddress                         : rawUser.lastEmailResetIpAddress ?? defaultUser.lastEmailResetIpAddress,
  lastEmailResetDate                              : new Date           ( rawUser.lastEmailResetDate    ?? new Date() ),
  lastEmailResetPreviousEmail                     : rawUser.lastEmailResetPreviousEmail ?? defaultUser.lastEmailResetPreviousEmail,
  lastEmailResetPreviousEmailValidationToken      : rawUser.lastEmailResetPreviousEmailValidationToken ?? defaultUser.lastEmailResetPreviousEmailValidationToken,
  lastEmailResetPreviousEmailValidationIpAddress  : rawUser.lastEmailResetPreviousEmailValidationIpAddress ?? defaultUser.lastEmailResetPreviousEmailValidationIpAddress,
  lastEmailResetPreviousEmailValidationDate       : new Date           ( rawUser.lastEmailResetPreviousEmailValidationDate    ?? new Date() ),

  ipApiCom_country : rawUser.ipApiCom_country,
  ipApiCom_city    : rawUser.ipApiCom_city,
  ipApiCom_lat     : rawUser.ipApiCom_lat,
  ipApiCom_lon     : rawUser.ipApiCom_lon,
  ipApiCom_isp     : rawUser.ipApiCom_isp,

               firstname           : rawUser.firstname ?? defaultUser.firstname,
               lastname            : rawUser.lastname ?? defaultUser.lastname,
               sex                 : rawUser.sex ?? defaultUser.sex,
               birthday            : rawUser.birthday ? convertStringToDate(rawUser.birthday, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.birthday,
               address             : rawUser.address ?? defaultUser.address,
               address2            : rawUser.address2 ?? defaultUser.address2,
               address3            : rawUser.address3 ?? defaultUser.address3,
               zipCode             : rawUser.zipCode ?? defaultUser.zipCode,
               city                : rawUser.city ?? defaultUser.city,
               country             : rawUser.country ?? defaultUser.country,
               phoneNumber         : rawUser.phoneNumber ?? defaultUser.phoneNumber,

               lastLoginDate       : rawUser.lastLoginDate ? convertStringToDate(rawUser.lastLoginDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.lastLoginDate,
               lastLoginIpAddress  : rawUser.lastLoginIpAddress ?? defaultUser.lastLoginIpAddress,
               lastLoginCity       : rawUser.lastLoginCity ?? defaultUser.lastLoginCity,

               purchases           : rawUser.purchases ?? defaultUser.purchases,
             };

           return {
                   code    : 1,
                   comment : 'La récupération du user est terminée.',
                   payload : user,
                  };
          }
     else {
           return handleError<User>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<User>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<User>(-102, 'Erreur inconnue');
   }
 };

export const getUserByEmail = async (userEmail: string): Promise<BackendResponse_User> => {

  let url = API_URLS.getUserByEmail;

  const queryParams = new URLSearchParams();

  queryParams.append ( 'email' , userEmail );

  if (queryParams.toString()) url += `?${queryParams.toString()}`;

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
           const defaultUser = initializedUser();
           const rawUser     = response.data

           const user: User = {

               ...defaultUser,
               id                  : rawUser.id ?? defaultUser.id,
               creationDate        : rawUser.creationDate ? convertStringToDate(rawUser.creationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.creationDate,
               creationIpAddress   : rawUser.creationIpAddress ?? defaultUser.creationIpAddress,
               email               : rawUser.email ?? defaultUser.email,
               emailValidationDate : rawUser.emailValidationDate ? convertStringToDate(rawUser.emailValidationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.emailValidationDate,
               status              : rawUser.status ?? defaultUser.status,
               statusDeadline      : rawUser.statusDeadline ? convertStringToDate(rawUser.statusDeadline, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.statusDeadline,
               locked              : (rawUser.locked === 'true') ?? defaultUser.locked,

  nextStatus                                      : rawUser.nextStatus ?? defaultUser.nextStatus,
  nextStatusRequestDate                           : rawUser.nextStatusRequestDate ? new Date(rawUser.nextStatusRequestDate) : null,
  nextStatusRequestIpAddress                      : rawUser.nextStatusRequestIpAddress ?? defaultUser.nextStatusRequestIpAddress,
  state                                           : rawUser.state ?? defaultUser.state,
  closureDate                                     : rawUser.closureDate ? new Date(rawUser.closureDate) : null,
  closureIpAddress                                : rawUser.closureIpAddress ?? defaultUser.closureIpAddress,
  lastBanDate                                     : rawUser.lastBanDate ? new Date(rawUser.lastBanDate) : null,
  lastUpdateIpAddress                             : rawUser.lastUpdateIpAddress ?? defaultUser.lastUpdateIpAddress,
  lastUpdateDate                                  : rawUser.lastUpdateDate ? new Date(rawUser.lastUpdateDate) : null,
  emailValidationToken                            : rawUser.emailValidationToken ?? defaultUser.emailValidationToken,
  emailValidationIpAddress                        : rawUser.emailValidationIpAddress ?? defaultUser.emailValidationIpAddress,
  emailValidationReminder                         : rawUser.emailValidationReminder ?? defaultUser.emailValidationReminder,
  lastPasswordResetRequestIpAddress               : rawUser.lastPasswordResetRequestIpAddress ?? defaultUser.lastPasswordResetRequestIpAddress,
  lastPasswordResetRequestDate                    : new Date           ( rawUser.lastPasswordResetRequestDate    ?? new Date() ),
  lastPasswordResetToken                          : rawUser.lastPasswordResetToken ?? defaultUser.lastPasswordResetToken,
  lastPasswordResetIpAddress                      : rawUser.lastPasswordResetIpAddress ?? defaultUser.lastPasswordResetIpAddress,
  lastPasswordResetDate                           : new Date           ( rawUser.lastPasswordResetDate    ?? new Date() ),
  lastEmailResetRequestIpAddress                  : rawUser.lastEmailResetRequestIpAddress ?? defaultUser.lastEmailResetRequestIpAddress,
  lastEmailResetRequestDate                       : new Date           ( rawUser.lastEmailResetRequestDate    ?? new Date() ),
  lastEmailResetToken                             : rawUser.lastEmailResetToken ?? defaultUser.lastEmailResetToken,
  lastEmailResetIpAddress                         : rawUser.lastEmailResetIpAddress ?? defaultUser.lastEmailResetIpAddress,
  lastEmailResetDate                              : new Date           ( rawUser.lastEmailResetDate    ?? new Date() ),
  lastEmailResetPreviousEmail                     : rawUser.lastEmailResetPreviousEmail ?? defaultUser.lastEmailResetPreviousEmail,
  lastEmailResetPreviousEmailValidationToken      : rawUser.lastEmailResetPreviousEmailValidationToken ?? defaultUser.lastEmailResetPreviousEmailValidationToken,
  lastEmailResetPreviousEmailValidationIpAddress  : rawUser.lastEmailResetPreviousEmailValidationIpAddress ?? defaultUser.lastEmailResetPreviousEmailValidationIpAddress,
  lastEmailResetPreviousEmailValidationDate       : new Date           ( rawUser.lastEmailResetPreviousEmailValidationDate    ?? new Date() ),

  ipApiCom_country : rawUser.ipApiCom_country,
  ipApiCom_city    : rawUser.ipApiCom_city,
  ipApiCom_lat     : rawUser.ipApiCom_lat,
  ipApiCom_lon     : rawUser.ipApiCom_lon,
  ipApiCom_isp     : rawUser.ipApiCom_isp,

               firstname           : rawUser.firstname ?? defaultUser.firstname,
               lastname            : rawUser.lastname ?? defaultUser.lastname,
               sex                 : rawUser.sex ?? defaultUser.sex,
               birthday            : rawUser.birthday ? convertStringToDate(rawUser.birthday, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.birthday,
               address             : rawUser.address ?? defaultUser.address,
               address2            : rawUser.address2 ?? defaultUser.address2,
               address3            : rawUser.address3 ?? defaultUser.address3,
               zipCode             : rawUser.zipCode ?? defaultUser.zipCode,
               city                : rawUser.city ?? defaultUser.city,
               country             : rawUser.country ?? defaultUser.country,
               phoneNumber         : rawUser.phoneNumber ?? defaultUser.phoneNumber,

               lastLoginDate       : rawUser.lastLoginDate ? convertStringToDate(rawUser.lastLoginDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.lastLoginDate,
               lastLoginIpAddress  : rawUser.lastLoginIpAddress ?? defaultUser.lastLoginIpAddress,
               lastLoginCity       : rawUser.lastLoginCity ?? defaultUser.lastLoginCity,

               purchases           : rawUser.purchases ?? defaultUser.purchases,
             };

           return {
                   code    : 1,
                   comment : 'La récupération du user est terminée.',
                   payload : user,
                  };
          }
     else {
           return handleError<User>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<User>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<User>(-102, 'Erreur inconnue');
   }
 };


export interface BackendResponse_EnrichedUserList extends BackendResponse<EnrichedUser[]> {}


export const getEnrichedUsers = async (params: GetUserListParams = {}): Promise<BackendResponse_EnrichedUserList> => {

  // const ipDetailsList = await retrieveDetailledIpAddressInformations();
  // const users = await retrieveUserList(params);
  // const enrichedUsers = await Promise.all(users.map(async (user) => {

  const users = await getUserList (params)

  const enrichedUsers = await Promise.all(users.payload.map(async (user) => {
    const defaultUser = initializedEnrichedUser();
    const ipDetails = initializedDetailledIpAddressInformations() // await retrieveDetailledIpAddressInformationsByIp(user.creationIpAddress);

    return { ...defaultUser, ...user, ipDetails: ipDetails ?? undefined };
  }));

  return {
    code: 1,
    comment: 'Enriched users retrieval complete.',
    payload: enrichedUsers,
  };
};

export interface BackendResponse_UserCount extends BackendResponse<number> {}

export const getUserCountByStatus = async (status: string): Promise<BackendResponse_UserCount> => {

  const url = API_URLS.getUserCountByStatus;
  const fullUrl = `${url}?status=${status}`

  try
   {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
          {
           return {
                   code    : 1,
                   comment : 'La récupération du nombre d\'utilisateurs est terminée.',
                   payload : response.data.userCount,
                  };
          }
     else {
           return handleError<number>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<number>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<number>(-102, 'Erreur inconnue');
   }
 };


export const getUserStatusChange = async ( status     : string ,
                                           beginning  : Date ,
                                           ending     : Date ,
                                           changeType : string ): Promise<BackendResponse_UserCount> => {

  const url = API_URLS.getUserStatusChange;

  const beginningDate = convertDateToString ( beginning , 'yyyy-MM-dd')
  const endingDate    = convertDateToString ( ending    , 'yyyy-MM-dd')

  const fullUrl = `${url}?status=${status}&beginningDate=${beginningDate}&endingDate=${endingDate}&changeType=${changeType}`

  try
   {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
          {
           return {
                   code    : 1,
                   comment : 'La récupération du nombre d\'utilisateurs est terminée.',
                   payload : response.data.userCount,
                  };
          }
     else {
           return handleError<number>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<number>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<number>(-102, 'Erreur inconnue');
   }
 };


export const getUserListByStatusChange = async ( status     : string ,
                                                 beginning  : Date ,
                                                 ending     : Date ,
                                                 changeType : string ): Promise<BackendResponse_UserList> => {

  const url = API_URLS.getUserListByStatusChange;

  const beginningDate = convertDateToString ( beginning , 'yyyy-MM-dd')
  const endingDate    = convertDateToString ( ending    , 'yyyy-MM-dd')

  const fullUrl = `${url}?status=${status}&beginningDate=${beginningDate}&endingDate=${endingDate}&changeType=${changeType}`

  try
   {
    const response = await axios.get(fullUrl);
	
	console.log (response)

    if (response.status === 200)
          {
           const users: User[] = response.data.map ( (rawUser: any) => {

             const defaultUser = initializedUser();

             return {

               ...defaultUser,
               id                  : rawUser.id ?? defaultUser.id,
               creationDate        : rawUser.creationDate ? convertStringToDate(rawUser.creationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.creationDate,
               creationIpAddress   : rawUser.creationIpAddress ?? defaultUser.creationIpAddress,
               email               : rawUser.email ?? defaultUser.email,
               emailValidationDate : rawUser.emailValidationDate ? convertStringToDate(rawUser.emailValidationDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.emailValidationDate,
               status              : rawUser.status ?? defaultUser.status,
               statusDeadline      : rawUser.statusDeadline ? convertStringToDate(rawUser.statusDeadline, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.statusDeadline,
               locked              : (rawUser.locked === 'true') ?? defaultUser.locked,

  nextStatus                                      : rawUser.nextStatus ?? defaultUser.nextStatus,
  nextStatusRequestDate                           : rawUser.nextStatusRequestDate ? new Date(rawUser.nextStatusRequestDate) : null,
  nextStatusRequestIpAddress                      : rawUser.nextStatusRequestIpAddress ?? defaultUser.nextStatusRequestIpAddress,
  state                                           : rawUser.state ?? defaultUser.state,
  closureDate                                     : rawUser.closureDate ? new Date(rawUser.closureDate) : null,
  closureIpAddress                                : rawUser.closureIpAddress ?? defaultUser.closureIpAddress,
  lastBanDate                                     : rawUser.lastBanDate ? new Date(rawUser.lastBanDate) : null,
  lastUpdateIpAddress                             : rawUser.lastUpdateIpAddress ?? defaultUser.lastUpdateIpAddress,
  lastUpdateDate                                  : rawUser.lastUpdateDate ? new Date(rawUser.lastUpdateDate) : null,
  emailValidationToken                            : rawUser.emailValidationToken ?? defaultUser.emailValidationToken,
  emailValidationIpAddress                        : rawUser.emailValidationIpAddress ?? defaultUser.emailValidationIpAddress,
  emailValidationReminder                         : rawUser.emailValidationReminder ?? defaultUser.emailValidationReminder,
  lastPasswordResetRequestIpAddress               : rawUser.lastPasswordResetRequestIpAddress ?? defaultUser.lastPasswordResetRequestIpAddress,
  lastPasswordResetRequestDate                    : new Date           ( rawUser.lastPasswordResetRequestDate    ?? new Date() ),
  lastPasswordResetToken                          : rawUser.lastPasswordResetToken ?? defaultUser.lastPasswordResetToken,
  lastPasswordResetIpAddress                      : rawUser.lastPasswordResetIpAddress ?? defaultUser.lastPasswordResetIpAddress,
  lastPasswordResetDate                           : new Date           ( rawUser.lastPasswordResetDate    ?? new Date() ),
  lastEmailResetRequestIpAddress                  : rawUser.lastEmailResetRequestIpAddress ?? defaultUser.lastEmailResetRequestIpAddress,
  lastEmailResetRequestDate                       : new Date           ( rawUser.lastEmailResetRequestDate    ?? new Date() ),
  lastEmailResetToken                             : rawUser.lastEmailResetToken ?? defaultUser.lastEmailResetToken,
  lastEmailResetIpAddress                         : rawUser.lastEmailResetIpAddress ?? defaultUser.lastEmailResetIpAddress,
  lastEmailResetDate                              : new Date           ( rawUser.lastEmailResetDate    ?? new Date() ),
  lastEmailResetPreviousEmail                     : rawUser.lastEmailResetPreviousEmail ?? defaultUser.lastEmailResetPreviousEmail,
  lastEmailResetPreviousEmailValidationToken      : rawUser.lastEmailResetPreviousEmailValidationToken ?? defaultUser.lastEmailResetPreviousEmailValidationToken,
  lastEmailResetPreviousEmailValidationIpAddress  : rawUser.lastEmailResetPreviousEmailValidationIpAddress ?? defaultUser.lastEmailResetPreviousEmailValidationIpAddress,
  lastEmailResetPreviousEmailValidationDate       : new Date           ( rawUser.lastEmailResetPreviousEmailValidationDate    ?? new Date() ),

  ipApiCom_country : rawUser.ipApiCom_country,
  ipApiCom_city    : rawUser.ipApiCom_city,
  ipApiCom_lat     : rawUser.ipApiCom_lat,
  ipApiCom_lon     : rawUser.ipApiCom_lon,
  ipApiCom_isp     : rawUser.ipApiCom_isp,

               firstname           : rawUser.firstname ?? defaultUser.firstname,
               lastname            : rawUser.lastname ?? defaultUser.lastname,
               sex                 : rawUser.sex ?? defaultUser.sex,
               birthday            : rawUser.birthday ? convertStringToDate(rawUser.birthday, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.birthday,
               address             : rawUser.address ?? defaultUser.address,
               address2            : rawUser.address2 ?? defaultUser.address2,
               address3            : rawUser.address3 ?? defaultUser.address3,
               zipCode             : rawUser.zipCode ?? defaultUser.zipCode,
               city                : rawUser.city ?? defaultUser.city,
               country             : rawUser.country ?? defaultUser.country,
               phoneNumber         : rawUser.phoneNumber ?? defaultUser.phoneNumber,

               lastLoginDate       : rawUser.lastLoginDate ? convertStringToDate(rawUser.lastLoginDate, "yyyy-MM-dd'T'HH:mm:ssXXX") : defaultUser.lastLoginDate,
               lastLoginIpAddress  : rawUser.lastLoginIpAddress ?? defaultUser.lastLoginIpAddress,
               lastLoginCity       : rawUser.lastLoginCity ?? defaultUser.lastLoginCity,

               purchases           : rawUser.purchases ?? defaultUser.purchases,
             };
           } );

           return {
                   code    : 1,
                   comment : 'La récupération des utilisateurs est terminée.',
                   payload : users,
                  };
          }
     else {
           return handleError<User[]>(response.status, 'Réponse non-200 de l\'API', []);
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<User[]>(-101, error.response?.data?.detail ?? error.message, []);
     }

    return handleError<User[]>(-102, 'Erreur inconnue', []);
   }
 };



export interface BackendResponse_UserAuthenticationResultList extends BackendResponse<UserAuthenticationResult[]> {}

export const getUserAuthenticationResultList = async ( beginning? : Date   , 
                                                       ending?    : Date   , 
													   userId?    : number ,
                                                       withAttempts = false ): Promise<BackendResponse_UserAuthenticationResultList> => {

  let url = API_URLS.getUserAuthenticationResultList;

  const params = new URLSearchParams();

  if (beginning) 
   {
   // params.append('beginningDateStr', convertDateToString ( beginning, 'yyyy/MM/dd HH:mm'));
   
    // L'instant réel : la base range les connexions en UTC, l'ancien décalage de l'offset
    // faisait manquer à « Aujourd'hui » les 2 premières heures de la journée (2026-10-18).
    params.append ( 'beginningDateStr' , beginning.toISOString() );
   }
   
  if (ending) 
   {
   // params.append('endingDateStr', convertDateToString ( ending, 'yyyy/MM/dd HH:mm'));
   
    params.append ( 'endingDateStr' , ending.toISOString() );
   }
   
  if (userId) 
   {
    params.append('userId', userId.toString());
   }

  // Onglet Trafic du Dashboard : aussi les tentatives refusées, comptes inconnus compris.
  if (withAttempts)
   {
    params.append('withAttempts', '1');
   }
   
  if (params.toString()) 
   {
    url += `?${params.toString()}`;
   }

  try 
   {
    const response = await axios.get(url);

    if (response.status === 200) 
	      {
      
	       const payload: UserAuthenticationResult[] = response.data.map((item: any) => ({
        
		      id        : item.userId ?? 0,
              email     : item.userEmail,
              status    : item.result,
              date      : new Date (item.actionDate),
              firstName : '',
              lastName  : '',
		      ipAddress : item.ipAddress,
	          country   : item.country,
              city      : item.city,
              lat       : item.lat,
              lon       : item.lon,
              isp       : item.isp,
              origin    : item.origin ?? null,
              role      : item.role ?? null,
              app       : item.app ?? null,
              firstTime : !!item.firstTime,
              unknown   : !!item.unknownAccount,
              reason    : item.reason ?? null
            }));

           return {
              code    : 1,
              comment : 'La récupération des résultats d\'authentification des utilisateurs est terminée.',
              payload : payload,
            };
			
          } 
	 else {
           return handleError<UserAuthenticationResult[]>(response.status, 'Réponse non-200 de l\'API');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<UserAuthenticationResult[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<UserAuthenticationResult[]>(-102, 'Erreur inconnue');
   }
};


export interface BackendResponse_UserExistence extends BackendResponse<boolean> {}

export const getUserExistenceCheck = async ( rawField: string             , 
                                             rawValue: string             ,
											 email?:   string | undefined ): Promise<BackendResponse_UserExistence> => {

    const baseUrl  =  `${API_URLS.getUserExistenceCheck}?`;

    const name1  = "field="; 
    const name2  = "value=";
    const value1 = encodeURIComponent (rawField);      
    const value2 = encodeURIComponent (rawValue); 

    var url = `${baseUrl}${name1}${value1}&${name2}${value2}`;

    if ( typeof ( email ) !== "undefined" )
	 {
      url = url + `&email=${email}`;
	 }
		  
/*	const userAgentInformations = getUserAgentInformations ();
	const appInformations       = getAppInformations ();

    const headers = {
	    'User-Agent-Informations': `${userAgentInformations}`,
	    'App-Informations': `${appInformations}`,
    };
	*/	  
    var result:BackendResponse_UserExistence = {
      code:    0,
      comment: "",
	  payload: false,
    };

    try {

		const response = await axios.get ( url ); //, { headers: headers } );
		
		const statut   = response.status;
		const exist    = response.data['hydra:member'][0].exist;

		if ( statut === 200 )
		      {
			   if (exist === "true" ) 
		             {
                      result = {
                        code:    1,
                        comment: "Utilisateur trouvé",
						payload: true
					   }
                     }
                else {
                      result = {
                        code:    1,
                        comment: "Utilisateur non trouvé",
						payload: false
                      };        
				     }			   
		      }
		 else {
               result = {
                 code:    -101,
                 comment: `Erreur lors de la recherche de l'utilisateur : ${response.status}`,
				 payload: false
               };        
		      }
    } 
    catch (err) {
	
        result = {
		  code:    -201,
		  comment: "Erreur réseau",
		  payload: false
		};           
    }

    return result;
};

// Fonction pour mettre à jour une vidéo existante
export const patchUser = async (  id:                  number      ,
                                  email:               string      ,
                                  firstname:           string      ,
                                  lastname:            string      ,
                                  sex:                 string      ,
                                  birthday:            Date | null ,
                                  address:             string      ,
                                  address2:            string      ,
                                  zipCode:             string      ,
                                  city:                string      ,
                                  country:             string      ,
                                  phoneNumber:         string      ,
								  status:              string      ,
								  statusDeadline:      Date | null ,
								  locked:              boolean     ,
									  password:            string = '' ): Promise<BackendResponse> => {

  const url = `${API_URLS.patchUser}`;
  //const url = baseUrl.replace('{id}', `${id}`);

  const formData = new FormData();

  formData.append ('id'             , id.toString()   );
  formData.append ('email'          , email   );
  formData.append ('firstname'      , firstname   );
  formData.append ('lastname'       , lastname    );
  formData.append ('sex'            , sex         );
  formData.append ('birthday'       , convertDateToString (birthday, 'yyyy-MM-dd') );
  formData.append ('address'        , address     );
  formData.append ('address2'       , address2    );
  formData.append ('zipCode'        , zipCode     );
  formData.append ('city'           , city        );
  formData.append ('country'        , country     );
  formData.append ('phoneNumber'    , phoneNumber );
  formData.append ('status'         , status      );
  formData.append ('statusDeadline' , convertDateToString (statusDeadline, 'yyyy-MM-dd') );
  formData.append ('locked'         , locked.toString() );

  if (password !== '') formData.append ('password' , password );
  
  // const headers = {
    // 'Accept': 'application/ld+json',
    // 'Content-Type': 'multipart/form-data',
  // };


  try
   {
    const response = await axios.post ( url , formData );  

    if (response.status === 200 || response.status === 204 || response.status === 201) {
      return {
        code    : 1,
        comment : 'User updated successfully.',
        payload : {} as any
      };
    } else {
      return handleError<void>(response.status, 'Non-200/201/204 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Unknown error');
  }
};

export const createUser = async ( email:     string      ,
                                  password:  string      ,
                                  firstname: string      ,
                                  lastname:  string      ,
                                  sex:       string      ,
                                  birthday:  Date | null ): Promise<BackendResponse<number>> => {

  const url = API_URLS.createUser;

  try
   {
    const response = await axios.post ( url , { email , password , firstname , lastname , sex , birthday: convertDateToString (birthday, 'yyyy-MM-dd') } );

    if ( response.status === 200 || response.status === 201 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : response.data?.id ?? 0,
                  }
          }
     else {
           return handleError<number> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<number> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<number> ( -102 , 'Unknown error' );
   }
};






export interface BackendResponse_UserStatusList extends BackendResponse<UserStatus[]> {}

export const getUserStatusList = async (): Promise<BackendResponse_UserStatusList> => {

  let url = API_URLS.getUserStatusList;

  try
   {
    const response = await axios.get(url);


    if (response.status === 200)
          {
           const availableUserStatus: UserStatus[] = response.data['hydra:member'].map ( (rawUserStatus: any) => {

             const defaultUserStatus = initializedUserStatus();

             return { 

               ...defaultUserStatus,
               id    : rawUserStatus.id    ?? defaultUserStatus.id,
               value : rawUserStatus.value ?? defaultUserStatus.value,
               name  : rawUserStatus.name  ?? defaultUserStatus.name,
             };
           } );

           return {
                   code    : 1,
                   comment : 'La récupération des utilisateurs est terminée.',
                   payload : availableUserStatus,
                  };
          }
     else {
           return handleError<UserStatus[]>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    console.log (error)	   
	   
    if (axios.isAxiosError(error))
     {
      return handleError<UserStatus[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<UserStatus[]>(-102, 'Erreur inconnue');
   }
 };

export const updateUserLockStatus = async (userId: number, locked: boolean): Promise<BackendResponse<void>> => {

  /*
  const baseUrl = `${API_URLS.patchBroadcastingChannelVisibility}`;
  const url = baseUrl.replace('{id}', `${id}`);  // Remplacement de l'ID dans l'URL
  const visibilityStr = visibility ? 'true' : 'false';
  */

  const baseUrl = locked ? `${API_URLS.lockUser}` : `${API_URLS.unlockUser}`;
  const url     = baseUrl.replace('{id}', `${userId}`);

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try
   {
    const response = await axios.patch (url, {}, { headers });

    if (response.status === 200 || response.status === 204)
          {
           return {
                    code    : 1,
                    comment : 'User lock status updated successfully.',
                    payload : undefined,
                  };
          }
     else {
           return handleError<void>(response.status, 'Error updating the user lock status');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Network error');
   }
};

// Suppression (logique par défaut) d'un user. Le compte est clôturé et non réellement supprimé,
// sauf appel explicite avec complete=true (non utilisé côté front pour l'instant).
export const deleteUser = async (userId: number, adminId?: number): Promise<BackendResponse<void>> => {

  const baseUrl = `${API_URLS.deleteUser}`;
  const url     = baseUrl.replace('{id}', `${userId}`);

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept'                   : 'application/ld+json',
    'User-Agent-Informations'  : `${userAgentInformations}`,
    'App-Informations'         : `${appInformations}`,
    'X-Admin-Id'               : adminId ?? '',
  };

  try
   {
    const response = await axios.delete (url, { headers });

    if (response.status === 200 || response.status === 204)
          {
           return {
                    code    : 1,
                    comment : 'User deleted successfully.',
                    payload : undefined,
                  };
          }
     else {
           return handleError<void>(response.status, 'Error deleting the user');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Network error');
   }
};

